// extracted by mini-css-extract-plugin
export default {"svg":"serves_svg__fmd34","div":"serves_div__WD8nc","serveses":"serves_serveses__anr-2","openRow":"serves_openRow__KRCra","companiesCardLogo":"serves_companiesCardLogo__TRp8l"};